import {
  GridActionsCellItem,
  GridRowParams,
} from '@mui/x-data-grid';
import { Paper, IconButton, Grid, Tooltip } from '@mui/material';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link as RouterLink, useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import DataList from '../../../components/DataList';
import useConfirmDeleteDialog from '../../../hooks/useConfirmDeleteDialog';
import platformRoleService from './platformRoleService';

const PlatformRolesPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<any[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const { ConfirmDeleteDialog, setParams } = useConfirmDeleteDialog();

  const load = () => {
    dispatch({ type: 'SHOW_QUERY' });
    platformRoleService
      .list()
      .then((response) => {
        if (!response.hasError) {
          setRows(
            (response.records ?? []).map((x: any) => ({
              ...x,
              id: x.id ?? x.Id,
              name: x.name ?? x.Name,
              description: x.description ?? x.Description ?? '',
              isSystem: x.isSystem ?? x.IsSystem,
              permissionCount: x.permissionCount ?? x.PermissionCount ?? 0,
            }))
          );
        } else {
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        }
      })
      .finally(() => dispatch({ type: 'HIDE' }));
  };

  useEffect(() => {
    load();
  }, []);

  const columns: any[] = [
    { field: 'name', headerName: 'Név', flex: 120 },
    { field: 'description', headerName: 'Leírás', flex: 160 },
    {
      field: 'permissionCount',
      headerName: 'Jogosultságok',
      flex: 80,
    },
    {
      field: 'isSystem',
      headerName: 'Rendszer',
      flex: 60,
      valueFormatter: (v: boolean) => (v ? 'Igen' : ''),
    },
    {
      field: 'actions',
      type: 'actions',
      flex: 60,
      getActions: (params: GridRowParams) => {
        const actions: any[] = [
          <GridActionsCellItem
            key="edit"
            icon={
              <Tooltip title="Szerkesztés">
                <EditIcon />
              </Tooltip>
            }
            label="Edit"
            color="primary"
            onClick={() =>
              navigate(`/authority/platform-roles/edit/${params.row.id}`)
            }
          />,
        ];
        if (!params.row.isSystem) {
          actions.push(
            <GridActionsCellItem
              key="delete"
              icon={
                <Tooltip title="Törlés">
                  <DeleteIcon />
                </Tooltip>
              }
              label="Delete"
              color="primary"
              onClick={() =>
                setParams({
                  open: true,
                  name: params.row.name,
                  onConfirm: async () => {
                    const response = await platformRoleService.delete(
                      params.row.id
                    );
                    if (response.hasError) {
                      enqueueSnackbar(
                        (response.errorMessages ?? []).join(','),
                        { variant: 'error' }
                      );
                    } else {
                      enqueueSnackbar('Törölve', { variant: 'success' });
                      load();
                    }
                  },
                })
              }
            />
          );
        }
        return actions;
      },
    },
  ];

  return (
    <Paper>
      <Grid container sx={{ p: 3 }} spacing={2}>
        <Grid size={12}>
          <h2>SaaS szerepkörök</h2>
        </Grid>
        <Grid container size={12} sx={{ justifyContent: 'end' }}>
          <Tooltip title="Új platform szerepkör">
            <IconButton
              component={RouterLink}
              to="/authority/platform-roles/create"
              color="primary"
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid size={12}>
          <DataList rows={rows} columns={columns} />
        </Grid>
        <ConfirmDeleteDialog />
      </Grid>
    </Paper>
  );
};

export default PlatformRolesPage;
